/**
 * Taken from https://github.com/mu29/react-stepper
 * This repo is archived and has out of date dependencies
 *
 * Plus we need to make a lot of adjustments to it!
 */
import React, { Component } from 'react';
import { bool, number, string } from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class Step extends Component {
  getStyles = () => {
    const {
      activeColor,
      completeColor,
      defaultColor,
      circleFontColor,
      size,
      circleFontSize,
      circleTop,
      completeOpacity,
      activeOpacity,
      defaultOpacity,
      barStyle,
      defaultBarColor,
      defaultBorderColor,
      completeBorderColor,
      activeBorderColor,
      defaultBorderStyle,
      completeBorderStyle,
      activeBorderStyle,
      lineMarginOffset,
      defaultBorderWidth
    } = this.props;

    return {
      circle: {
        width: size,
        height: size,
        margin: '0 auto',
        backgroundColor: defaultColor,
        borderRadius: '50%',
        textAlign: 'center',
        fontSize: circleFontSize,
        color: circleFontColor,
        display: 'block',
        opacity: defaultOpacity,
        borderWidth: defaultBorderColor ? defaultBorderWidth : 0,
        borderColor: defaultBorderColor,
        borderStyle: defaultBorderStyle
      },
      activeCircle: {
        backgroundColor: activeColor,
        opacity: activeOpacity,
        borderWidth: activeBorderColor ? defaultBorderWidth : 0,
        borderColor: activeBorderColor,
        borderStyle: activeBorderStyle
      },
      completedCircle: {
        backgroundColor: completeColor,
        opacity: completeOpacity,
        borderWidth: completeBorderColor ? defaultBorderWidth : 0,
        borderColor: completeBorderColor,
        borderStyle: completeBorderStyle
      },
      leftBar: {
        position: 'absolute',
        top: circleTop + size / 2 - 2,
        height: 1,
        borderTopStyle: barStyle,
        borderTopWidth: 5,
        borderTopColor: defaultBarColor,
        left: 0,
        right: '50%',
        marginRight: size / 2 + lineMarginOffset,
        opacity: defaultOpacity
      },
      rightBar: {
        position: 'absolute',
        top: circleTop + size / 2 - 2,
        height: 1,
        borderTopStyle: barStyle,
        borderTopWidth: 5,
        borderTopColor: defaultBarColor,
        right: 0,
        left: '50%',
        marginLeft: size / 2 + lineMarginOffset,
        opacity: defaultOpacity
      },
      completedBar: {
        borderTopStyle: barStyle,
        borderTopWidth: 5,
        borderTopColor: activeColor,
        opacity: completeOpacity
      }
    };
  };

  render() {
    const { title, index, active, completed, first, isLast, width } = this.props;

    const styles = this.getStyles();
    const circleStyle = Object.assign(
      styles.circle,
      completed ? styles.completedCircle : {},
      active ? styles.activeCircle : {}
    );
    const leftStyle = Object.assign(styles.leftBar, active || completed ? styles.completedBar : {});
    const rightStyle = Object.assign(styles.rightBar, completed ? styles.completedBar : {});

    let stepContent = index;
    if (completed) {
      stepContent = <FontAwesomeIcon icon="check" />;
    }

    let titleStyle = 'diy-step-title mt-2 text-center';
    if (active || completed) {
      titleStyle += ' diy-step-title-primary font-weight-bold';
    }

    return (
      <div className="d-table-cell position-relative pt-4" style={{ width: `${width}%` }}>
        <div style={circleStyle}>
          <span className="diy-step-content">{stepContent}</span>
        </div>
        <div className={titleStyle}>{title}</div>
        {!first && <div style={leftStyle} />}
        {!isLast && <div style={rightStyle} />}
      </div>
    );
  }
}

Step.defaultProps = {
  activeColor: '#24988B',
  completeColor: '#24988B',
  defaultColor: '#AAA',
  circleFontColor: '#FFF',
  size: 32,
  circleFontSize: 16,
  circleTop: 24,
  defaultBarColor: '#AAA',
  barStyle: 'solid',
  borderStyle: 'solid',
  lineMarginOffset: 4,
  defaultBorderWidth: 3
};

Step.propTypes = {
  width: number.isRequired,
  activeColor: string,
  completeColor: string,
  defaultColor: string,
  circleFontColor: string,
  size: number,
  circleFontSize: number,
  circleTop: number,
  title: string,
  index: number,
  active: bool,
  completed: bool,
  first: bool,
  isLast: bool,
  completeOpacity: string,
  activeOpacity: string,
  defaultOpacity: string,
  barStyle: string,
  borderStyle: string,
  defaultBarColor: string,
  defaultBorderColor: string,
  completeBorderColor: string,
  activeBorderColor: string,
  defaultBorderStyle: string,
  completeBorderStyle: string,
  activeBorderStyle: string,
  lineMarginOffset: number,
  defaultBorderWidth: number
};
